import * as React from "react";
import Box from "@mui/material/Box";
import {Container, Divider, SvgIcon} from "@mui/material";
import { ReactComponent as Facebook } from '../../assets/images/icons/facebook.svg';


type Props = {
    title: string,
    message: string,
    date: string,
    link: string,
    icon:string;
    /** false pour une alerte levée (design : plus de « détails »/partage — voir X-large-Page publique_v2 sur Figma). */
    showActions?: boolean;
}

function generateFacebookShareLink(url: string) {
    return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
}

const facebookShareLink = generateFacebookShareLink(window.location.href);

export default function Alertnotes ({ title, date, message, link, icon, showActions = true }: Props) {
    return(
        <Container className='alert'>
            <Box className='alert-body'>
                <Box className='alert-main'>
                    <Box className='alert-header'>
                        <Box className='alert-header__icon'>
                            <div dangerouslySetInnerHTML={{__html: icon}} className={'icon'} />
                        </Box>
                        <Box className='alert-header__content'>
                            <h4 className='title'>{title}</h4>
                            <p className='date'>{date}</p>
                        </Box>
                    </Box>
                    <Box className='alert-content'>
                        <p className='message'>{message}</p>
                    </Box>
                </Box>

                {/* À côté de l'alerte (pas en dessous du message) : colonne
                    d'actions séparée, à droite sur desktop, sous le contenu
                    sur mobile (voir _alert-notes.scss). */}
                {showActions && (
                    <Box className='alert-actions'>
                        <a href={link} className='btn btn-yellow'>Plus de détail</a>
                        <a href={facebookShareLink} target="_blank" className='share-button' rel="noopener noreferrer" > <SvgIcon className='share' component={Facebook} inheritViewBox /> </a>
                    </Box>
                )}
            </Box>
            <Divider/>
        </Container>
    )
}
